export const OUTBOUND_MULTIMEDIA_ACCEPTED_TYPES =
    'image/jpeg,image/png,image/gif,image/webp,application/pdf,video/mp4';

export const OUTBOUND_MULTIMEDIA_MAX_SIZE_BYTES = 16777216;
